/**
 * Illustration lookup. Files under src/assets/illustrations are discovered at build time,
 * so a new picture only needs dropping into the folder (see the README there).
 */
const files = import.meta.glob('../assets/illustrations/**/*.{webp,png,jpg,jpeg}', {
  eager: true,
  query: '?url',
  import: 'default',
}) as Record<string, string>;

const byKey = new Map<string, string>();
for (const [path, url] of Object.entries(files)) {
  const m = /illustrations\/(exercises|scenes)\/([^/]+)\.(?:webp|png|jpe?g)$/.exec(path);
  if (m) byKey.set(`${m[1]}/${m[2]}`, url);
}

export type SceneName =
  | 'hero-floor-reading'
  | 'report-ready-lap'
  | 'checkpoint-chai'
  | 'empty-children'
  | 'empty-reports'
  | 'programme-teaser'
  | 'payment-success'
  | 'care-team'
  | 'signin-hands'
  | 'not-found-kite'
  | 'offline-boat'
  | 'room-floor-play'
  | 'room-table-time'
  | 'room-mealtime'
  | 'room-calm-corner'
  | 'room-move-outdoors';

/** Existing pictures that stand in for a scene until its own illustration arrives. */
const SCENE_STAND_INS: Partial<Record<SceneName, string>> = {
  'hero-floor-reading': 'aba_joint_attention_02',
  'report-ready-lap': 'aba_joint_attention_01',
  'programme-teaser': 'aba_joint_attention_02',
  'empty-children': 'aba_joint_attention_01',
  'empty-reports': 'ot_finger_isolation_01',
  'checkpoint-chai': 'aba_two_word_request_01',
  'room-floor-play': 'aba_joint_attention_01',
  'room-table-time': 'ot_finger_isolation_01',
  'room-mealtime': 'aba_two_word_request_01',
  'room-calm-corner': 'si_sensory_regulation_01',
};

export const exerciseImage = (exerciseId: string): string | undefined => byKey.get(`exercises/${exerciseId}`);

export const sceneImage = (name: SceneName): string | undefined =>
  byKey.get(`scenes/${name}`) ?? (SCENE_STAND_INS[name] ? exerciseImage(SCENE_STAND_INS[name]!) : undefined);
